import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "padding-auth-contents" }
const _hoisted_2 = { class: "text-title-underline" }
const _hoisted_3 = { class: "card-outlined pt-3 px-3 md:pt-4 md:px-4" }
const _hoisted_4 = { class: "flex text-sm md:text-base" }
const _hoisted_5 = { class: "leading-tight pr-3" }
const _hoisted_6 = { class: "leading-tight" }
const _hoisted_7 = { class: "flex items-center justify-center mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_pagination = _resolveComponent("base-pagination")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t('notice.title')), 1),
            (Array.isArray(_ctx.notices) && _ctx.notices.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedList, (notice) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: notice.id,
                        class: "pb-3 md:pb-4"
                      }, [
                        _createVNode(_component_router_link, {
                          to: `/notice/${notice.id}`,
                          class: "text-link"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dayjs(notice.published_at).format('YYYY/MM/DD')), 1),
                              _createElementVNode("div", _hoisted_6, _toDisplayString(notice.title), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_base_pagination, {
                      pagedList: _ctx.pagedList,
                      "onUpdate:pagedList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagedList) = $event)),
                      originalList: _ctx.notices,
                      pageSize: _ctx.pageSize
                    }, null, 8, ["pagedList", "originalList", "pageSize"])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" お知らせが見つかりませんでした。 ")
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}